import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_ALL_USERS = restRequest("VRCORE_QUALIFICATIONS_OVERVIEW.GET_ALL_USERS");
export const GET_REQUIRED_QUALIFICATIONS = restRequest(
    "VRCORE_QUALIFICATIONS.GET_REQUIRED_QUALIFICATIONS"
);
export const GET_QUALIFICATION_CATEGORIES = restRequest(
    "VRCORE_QUALIFICATIONS_OVERVIEW.GET_QUALIFICATION_CATEGORIES"
);
export const SET_VIEW_CATEGORY_DETAILS = "VRCORE_QUALIFICATIONS_OVERVIEW.SET_VIEW_CATEGORY_DETAILS";
